import { css, useTheme } from '@emotion/react'
import Image from './Image'
import React from 'react'
import Link from './Link'

function MenuBody({ coloumn = 4, items = [] }) {
    const theme = useTheme()
    const style = css`
        display: grid;
        grid-template-columns: repeat(${coloumn}, minmax(0, 1fr));
        a {
            border: 1px dashed ${theme.colors?.lightGray};
            padding: 0.5rem;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 48px;
            text-align: center;
            border-radius: ${theme.borderRadius?.default};
        }
    `

    return (
        <div className="gap-2" css={style}>
            {items.map((item, idx) => {
                if (!item.thumbnail) {
                    return (
                        <Link key={idx} href={item.link}>
                            <span className="mx-2">{item.label}</span>
                        </Link>
                    )
                }
                return (
                    <Link key={idx} href={item.link}>
                        <Image
                            noStyle
                            src={item.thumbnail}
                            width={32}
                            height={32}
                            alt="flag"
                        />
                        <span className="mx-2">{item.label}</span>
                    </Link>
                )
            })}
        </div>
    )
}

export default MenuBody
